export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function getOffset(selectedPage, limit) {
  return (selectedPage ?? 0) * (limit ?? 10) - (limit ?? 10);
}
